// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-e96623e2]{color:#c81919}.basic--input[data-v-e96623e2]{max-width:250px;margin-right:16px}@media only screen and (max-width: 768px){.basic--input[data-v-e96623e2]{max-width:100%;margin-right:0;margin-bottom:8px}.basic--input[data-v-e96623e2]:last-child{margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
